import React, { useCallback, forwardRef } from 'react'

import PropTypes from 'prop-types'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import MuiSwitch from '@material-ui/core/Switch'

import useStyles from './styles'

const Switch = forwardRef((props, ref) => {
  const {
    id,
    className,
    label,
    onChange,
    checked,
    value,
    size,
    onClick,
    disabled,
    helperText,
    ...otherProps
  } = props

  const classes = useStyles()

  const handleChange = useCallback((event) => {
    if (!disabled) {
      onChange(event)
    }
  }, [disabled, onChange])

  return (
    <FormControlLabel
      className={ className }
      id={ id }
      onClick={ onClick }
      label={ label }
      classes={ classes }
      { ...otherProps }
      control={ (
        <MuiSwitch
          ref={ ref }
          value={ value }
          size={ size }
          id={ `${ id }-switch-input` }
          disabled={ disabled }
          onChange={ handleChange }
          checked={ !!checked }
          color="primary"
        />
      ) }
    />
  )
})

Switch.propTypes = {
  /** Identificador do Switch */
  id: PropTypes.string.isRequired,
  /** Classe para estilos */
  className: PropTypes.string,
  helperText: PropTypes.string,
  /** Texto que aparece ao lado do Switch */
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.element
  ]),
  /** Valor que o Switch representa */
  value: PropTypes.any,
  /** Estado do CheckBox (ativo, inativo, indeterminado)  */
  checked: PropTypes.oneOf([true, false, null]),
  /** Função no clique do mouse */
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium'])
}

Switch.defaultProps = {
  className: '',
  value: '',
  helperText: '',
  onChange: () => {},
  onClick: () => {},
  disabled: false,
  label: null,
  size: 'small',
  checked: false
}

export default Switch
